function Education() {
  return (
    <div id="education" className="pt-4">
      <div className="text-2xl">Education</div>
      <hr className="my-2" />
      <div className="text-sm lg:text-base">
        <div className="mt-2">
          <div className="font-bold">
            Bachelor of Science in Applied Computer Science
          </div>
          <div>British Columbia Institute of Technology</div>
          <div className="flex justify-between text-sm lg:text-base">
            <span>Burnaby, BC</span>
            <span>Sep 2024 - May 2026</span>
          </div>
        </div>
        <div className="mt-2">
          <div className="font-bold">
            Diploma in Computer Systems Technology
          </div>
          <div>British Columbia Institute of Technology</div>
          <div className="flex justify-between text-sm lg:text-base">
            <span>Burnaby, BC</span>
            <span>Jan 2022 - Dec 2023</span>
          </div>
        </div>
        <div className="mt-2">
          <div className="font-bold">
            Diploma in Architectural and Building Technology
          </div>
          <div>British Columbia Institute of Technology</div>
          <div className="flex justify-between text-sm lg:text-base">
            <span>Burnaby, BC</span>
            <span>Sep 2017 - May 2020</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Education;
